import withMapList from '../../../../../elements/HOC/withMapList'
import CustomDebounceSelect from '../../../../../elements/Select/CustomDebounceSelect'
import DateCell from '../../../../../elements/Table/Cells/DateCell'
import React, { Component, Fragment } from 'react'
import { Button, Col, Form, message, Row, Select } from 'antd'
import withSort from '../../../../../elements/HOC/withSort'
import CustomSelect from '../../../../../elements/Select/CustomSelect'
import withSpinning from '../../../../../elements/HOC/withSpinning'
import { compose } from 'recompose'
import { get, isEmpty } from 'lodash'
import withSubDropdown from '../../../../../elements/HOC/withSubDropdown'
import withSelectFetch from '../../../../../elements/Select/withSelectFetch'
import withLoadingSection from '../../../../../elements/HOC/withLoadingSection'
import CustomTable from '../../../../../elements/Table/CustomTable'
import Remittances from '../../../../../api/Sales/Remittances'
import Transactions from '../../../../../api/Finance/Transactions'
import {
  dateFormat,
  dateVal,
  moneyColumn,
  moneyInline,
  numVal,
  sessionItemByKeys,
  sessionItemVal,
  strVal,
} from '../../../../../modules/Utils'
import IconText from '../../../../../elements/IconText'
import withUrlFetch from '../../../../../elements/Select/withUrlFetch'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import moment from 'moment'
import PayrollClaims from '../../../../../api/People/PayrollClaims'
import { defaultFormItemLayout, fullWidthFormItemLayout } from '../../../../../modules/FormItems'

const DebitPurpose = compose(
  withSelectFetch({ dropdown: 'transactions', name: 'debit', forceFetch: true }),
  withSpinning,
  withSubDropdown({ name: 'purpose' }),
  withSort
)(CustomSelect)

class AllocationForm extends Component {
  state = { BankSelectCmp: Select, selection: [] }
  api = new Remittances()
  payrollClaimsApi = new PayrollClaims()
  transactionsApi = new Transactions()

  componentDidMount() {
    this.onChangePurpose(get(this.props.transaction, 'debit.purpose'))
    this.onChangeCompany(strVal(this.props, 'transaction.company._id'))
    this.onChangeBank(strVal(this.props, 'transaction.bank._id'))
  }

  fetch = async (type, company) => {
    try {
      this.setState({
        fetching: true,
      })
      const data = await this.api.allocation(type, company, this.props.transaction.bank._id)
      this.setState({
        data,
        company,
        type,
      })
      this.setState({
        fetching: false,
      })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({
        fetching: false,
      })
    }
  }
  fetchTransactions = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const data = await this.transactionsApi.allocation(this.props.transaction._id)
      this.setState({
        data,
      })
      this.setState({
        fetching: false,
      })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({
        fetching: false,
      })
    }
  }
  fetchPayrollClaims = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const data = await this.payrollClaimsApi.list({
        status: 'Paid',
        company: strVal(this.props, 'transaction.company._id'),
      })
      this.setState({
        data,
      })
      this.setState({
        fetching: false,
      })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({
        fetching: false,
      })
    }
  }
  onChangePurpose = (purpose) => {
    this.setState({ data: [] })
    switch (purpose) {
      case 'bank-fee':
        this.setState({
          type: 'bank-fee',
        })
        break
      case 'transfer-fee':
        this.setState({
          type: purpose,
        })
        this.fetchTransactions()
        break
      case 'payroll-claim':
        this.setState({
          type: purpose,
        })
        this.fetchPayrollClaims()
        break
      case 'bank-transfer':
        this.fetch('Bank Transfer', this.props.transaction.company._id)
        break
      case 'account-transfer':
        this.fetch('Account Transfer', this.props.transaction.company._id)
        break
      case 'inter-company-transfer':
        this.fetch('Intercompany Transfer')
        break
      case 'vendor-claim':
        this.fetch('Vendor Claim')
        break
      default:
        this.setState({
          data: [],
        })
        break
    }
  }
  columns = [
    {
      Header: 'Remittance',
      accessor: 'code',
    },
    {
      Header: 'Date Created',
      accessor: 'date',
      Cell: DateCell,
    },
    {
      Header: 'From Amount',
      accessor: 'from.amount',
    },
    // {
    //   Header: 'To Amount',
    //   accessor: 'to.amount',
    // },
    {
      Header: 'From Currency',
      accessor: 'from.currency',
    },
    {
      Header: 'To Currency',
      accessor: 'to.currency',
    },
    {
      Header: 'Payer Bank',
      accessor: 'from.bank.nickname',
    },
    {
      Header: 'Payee Bank',
      accessor: 'to.bank.nickname',
    },
  ]

  transactionsColumns = [
    {
      Header: 'ID',
      accessor: '_key',
    },
    {
      Header: 'Date',
      accessor: 'date',
      Cell: ({ original, value }) => dateFormat(moment(value)),
    },
    {
      Header: 'Company',
      accessor: 'company.fn',
      width: 400,
    },
    {
      Header: 'Bank Account',
      accessor: 'bank.title',
      width: 250,
    },
    {
      Header: 'Type',
      accessor: 'type',
      Cell: ({ value }) => sessionItemVal('transactions_type_dropdown', value),
    },
    {
      Header: 'Currency',
      accessor: 'bank.bank.currency',
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      style: { textAlign: 'right' },
      sortMethod: (a, b) => (Number.parseFloat(a) < Number.parseFloat(b) ? 1 : -1),
      Cell: ({ value }) => moneyColumn(value),
      filterMethod: (filter, row) => numVal(row, filter.id).toString().includes(filter.value),
    },
  ]
  payrollClaimsColumns = [
    {
      Header: 'ID',
      accessor: '_key',
    },
    {
      Header: 'Date',
      accessor: 'date',
      Cell: ({ original, value }) => dateFormat(moment(value)),
    },
    {
      Header: 'Type',
      accessor: 'type',
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      style: { textAlign: 'right' },
      sortMethod: (a, b) => (Number.parseFloat(a) < Number.parseFloat(b) ? 1 : -1),
      Cell: ({ value }) => moneyColumn(value),
      filterMethod: (filter, row) => numVal(row, filter.id).toString().includes(filter.value),
    },
    {
      Header: 'Currency',
      accessor: 'currency',
    },
  ]

  onChangeBank = (bank) => {
    let sessionID = `banks_${this.state.url}_dropdown`
    const currency = strVal(sessionItemByKeys(sessionID, bank, '_id', 'bank'), 'currency')
    this.setState({
      currency,
    })
  }
  onChangeCompany = (company) => {
    const url = `corporates/banks/?status=Active` + (isEmpty(company) ? '' : `&owner=${company}`)
    const BankSelectCmp = compose(
      withUrlFetch({
        name: 'banks',
        url: url,
        cache: true,
      }),
      withSpinning,
      withSort
    )(CustomSelect)
    this.props.form.resetFields(['bank._id', 'currency'])
    this.setState({ company, BankSelectCmp, url })
  }
  toggleSelection = (key) => {
    const selection = [key]
    this.setState({ selection })
  }
  isSelected = (key) => {
    return this.state.selection.includes(key)
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { transaction, allocate, unallocate, allocating, allocateRemi } = this.props
    const { toggleSelection, isSelected } = this
    const { data, fetching, type, selection } = this.state

    const checkboxProps = {
      selectType: 'radio',
      toggleSelection,
      isSelected,
      selection,
    }
    const columnsOptions = {
      'transfer-fee': this.transactionsColumns,
      'payroll-claim': this.payrollClaimsColumns,
    }
    const CheckboxTable = checkboxHOC(CustomTable)

    const columns = columnsOptions[this.props.form.getFieldValue('debit.purpose')] || this.columns

    const lenderContracts = get(transaction, 'bank._key')
    const RemittancesSelect = compose(
      withUrlFetch({
        name: 'remittances',
        url: `remittances?select=*&lenderContracts=${lenderContracts}&status=Rejected`,
        dontFetch: isEmpty(transaction) || get(transaction, 'receipt.type') !== 'refund',
      }),
      withSpinning,
      withMapList((i) => {
        console.log(i, 111)
        return {
          ...i,
          display: `[${i.code}] Amount ${i.from.amount} ${i.from.currency} From "${i.from.payor.fn}" To "${i.to.payee.fn}"`,
        }
      })
    )(CustomDebounceSelect)

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: {
          span: 16,
          offset: 1,
        },
      },
    }
    console.log(get(transaction, 'receipt.type'), 12)
    return (
      <Form>
        <Row>
          <Col span={16}>
            <Form.Item {...defaultFormItemLayout} label={'Company'}>
              <span>{get(transaction, 'company.fn')}</span>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...fullWidthFormItemLayout} label={'Transaction Date'}>
              <span>{dateFormat(dateVal(transaction, 'date'))}</span>
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item {...defaultFormItemLayout} label={'Bank Account'}>
              <span> {get(transaction, 'bank.title')}</span>
              <IconText style={{ marginLeft: 8 }} type={'bank'} text={get(transaction, 'currency')} />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item {...fullWidthFormItemLayout} label={'Amount'}>
              {moneyInline(numVal(transaction, 'amount'), get(transaction, 'currency'))}
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item {...defaultFormItemLayout} label={'Notes'}>
              <span>{get(transaction, 'notes')}</span>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...fullWidthFormItemLayout} label={'Transaction Ref'}>
              <span>{get(transaction, 'remittance.ref')}</span>
            </Form.Item>
          </Col>
        </Row>
        {get(transaction, 'allocated') && get(transaction, 'receipt.type') !== 'refund' ? (
          <Fragment>
            <Row>
              <Col span={16}>
                <Form.Item {...defaultFormItemLayout} label={'Purpose'}>
                  <span>{get(transaction, 'debit.purpose')}</span>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item {...fullWidthFormItemLayout} label={'Allocation'}>
                  <a>{get(transaction, 'allocation.code') || get(transaction, 'allocation._id')}</a>
                </Form.Item>
              </Col>
            </Row>
            <Button onClick={unallocate} loading={allocating} type={'danger'}>
              UnAllocate
            </Button>
          </Fragment>
        ) : (
          get(transaction, 'type') === 'debit' && (
            <Fragment>
              <Row>
                <Col span={24}>
                  <Form.Item {...defaultFormItemLayout} label={'Debit Purpose'}>
                    {getFieldDecorator('debit.purpose', {
                      initialValue: get(transaction, 'debit.purpose'),
                      rules: [
                        {
                          required: true,
                          message: 'Please Select a Debit Purpose!',
                        },
                      ],
                    })(<DebitPurpose style={{ width: '50%' }} onChange={this.onChangePurpose} />)}
                  </Form.Item>
                </Col>
              </Row>
              <Button onClick={() => allocate(selection, type)} type={'primary'} loading={allocating}>
                Allocate
              </Button>
              {this.props.form.getFieldValue('debit.purpose') !== 'bank-fee' && (
                <CheckboxTable
                  data={data}
                  columns={columns}
                  hide={{ fetch: true }}
                  fetching={fetching}
                  {...checkboxProps}
                />
              )}
            </Fragment>
          )
        )}
        {get(transaction, 'receipt.type') === 'refund' && (
          <Row>
            <Col span={24}>
              <Form.Item {...formItemLayout} label={'Remittance'}>
                {getFieldDecorator('remittance._id', {
                  initialValue: get(transaction, 'remittance._id'),
                  rules: [
                    {
                      required: true,
                      message: 'Please Select a Remittance!',
                    },
                  ],
                })(
                  <RemittancesSelect keyAtr={'_id'} valueAtr={'display'} style={{ width: '100%' }} className="left-0" />
                )}
                <Button onClick={allocateRemi} type={'primary'} loading={allocating}>
                  Allocate
                </Button>
              </Form.Item>
            </Col>
          </Row>
        )}
      </Form>
    )
  }
}

AllocationForm.propTypes = {}
AllocationForm.defaultProps = {}

export default compose(Form.create(), withLoadingSection)(AllocationForm)
